import React from "react";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../App.css";

function Supplies() {
  return (
    <>
      <Container fluid className="bgyellow rounded">
        <Row>
          <Col lg={6}>
            <h5 className="text-yellow mx-3 mt-5">
              Improving Efficiency Across Power Distribution Networks
            </h5>
            <h2 className="text-light mx-3 ">
              Reliable Electrical Hardware Designed for Today’s Utility and
              Infrastructure Demands{" "}
            </h2>
          </Col>

          <Col lg={6} className="mb-5">
            <p className="text-light mt-5 pt-4 px-2">
              Backed by an experienced team, we manufacture and supply durable
              electrical components trusted across India for power and utility
              applications.
            </p>
            <Link to="/about" className="btn btn-warning">
              <i class="fa-solid fa-circle-arrow-right fa-beat"> </i> Our Core
              Values
            </Link>
            {/* <Button variant="outline-success m-3"><i class="fa-solid fa-circle-arrow-right fa-beat"></i> Selling Support</Button> */}
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Supplies;
